import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Group,
  SegmentedControl,
  Text,
  Anchor,
  TextInput,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

import { PaginatedList } from "@components/shared";
import { CurateArtist } from "@components/Curation";
import entityIcon from "@util/entityIcon";

export default function ArtistList({
  requestInfo = {
    url: `/retrieve-artists/`,
    data: {},
  },
  refresh,
}) {
  const [refreshing, setRefreshing] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState({
    curated: "true",
  });

  const reqData = {
    ...requestInfo.data,
    search_value: searchValue,
    refresh,
    status: 1,
    curated: filters.curated === "true" ? true : false,
    refreshing,
  };

  return (
    <div>
      {requestInfo && (
        <>
          <TextInput
            placeholder="Search for an artist..."
            size="lg"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <SegmentedControl
            value={filters.curated}
            mt="xs"
            data={[
              { label: "Curated", value: "true" },
              { label: "Uncurated", value: "false" },
            ]}
            onChange={(e) => setFilters({ ...filters, curated: e })}
          />
        </>
      )}
      <PaginatedList
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: m.is_curated ? `/artists/${m.id}` : `/artists/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card key={item.original.id}>
            <Group align="center" gap="sm">
              <div>
                <Anchor
                  c="dark"
                  fw={700}
                  component={Link}
                  to={item.original.link_url}
                >
                  {item.original.name}
                </Anchor>
              </div>
              {item.original.is_curated ? (
                <IconCheck
                  size={16}
                  stroke={5}
                  color="var(--mantine-color-green-6)"
                  title="Curated"
                />
              ) : (
                <CurateArtist
                  artist={item.original}
                  onSuccess={() => setRefreshing(!refreshing)}
                  iconButton
                />
              )}
            </Group>
            {item.original.song_count && (
              <Group gap="xs" align="center">
                <div>{entityIcon.song(16)}</div>
                <Text size="sm">
                  {item.original.song_count} song
                  {item.original.song_count === 1 ? "" : "s"}
                </Text>
              </Group>
            )}
          </Card>
        )}
      />
    </div>
  );
}
